import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f3f5fb',
      100: '#c6d1ed',
      200: '#99adde',
      300: '#6c89cf',
      400: '#3f64c1',
      500: '#1240b2',
      600: '#0f3697',
      700: '#0d2d7d',
      800: '#0a2362',
      900: '#071a47',
      950: '#05102d',
    },
  },
});

export default MyPreset;
